import { MapPin } from 'lucide-react';
import { HomeJobItemCard } from './HomeJobItemCard';

interface HomeJobItem {
  id: string;
  title: string;
  timeText: string;
  distanceText: string;
  peopleNeededText: string;
  payText: string;
  tag?: string;
}

interface JobTickerProps {
  title: string;
  subtitle: string;
  jobs: HomeJobItem[];
  onJobClick: (jobId: string) => void;
  onEmptyClick: () => void;
}

export function JobTicker({ title, subtitle, jobs, onJobClick, onEmptyClick }: JobTickerProps) {
  const handleItemClick = (jobId: string) => (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onJobClick(jobId);
  };

  return (
    <div 
      className="rounded-2xl border border-slate-200 bg-white/60 p-4 sm:p-5 backdrop-blur-sm"
      onClick={onEmptyClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <MapPin className="h-5 w-5 text-emerald-600" />
          <h3 className="font-bold text-slate-950">{title}</h3>
        </div>
        <span className="text-sm text-slate-500">{subtitle}</span>
      </div>

      <div className="flex max-h-[220px] flex-col gap-3 overflow-y-auto pr-1 sm:max-h-none sm:flex-row sm:overflow-x-auto sm:overflow-y-hidden sm:pb-2 sm:pr-0">
        {jobs.map((job) => (
          <HomeJobItemCard
            key={job.id}
            job={job}
            onClick={handleItemClick(job.id)}
          />
        ))}
      </div>
    </div>
  );
}
